export const upcomingBookingsSelector = state => state.upcomingBookings.get('bookings');
export const upcomingBookingsIsLoadingSelector = state => state.upcomingBookings.get('isLoading');
